import React from 'react';
import FormGroup from '../../components/FormGroup';
import HARAssessmentTypeFilter from './filters/HARAssessmentTypeFilter';
import HARConditionFilter from './filters/HARConditionFilter';
import HARCountyFilter from './filters/HARCountyFilter';
import HARDistrictFilter from './filters/HARDistrictFilter';
import HARGradeFilter from './filters/HARGradeFilter';
import HARHeritageCategoriesFilter from './filters/HARHeritageCategoriesFilter';
import HARHistoricEnglandRegionFilter from './filters/HARHistoricEnglandRegionFilter';
import HARLocalPlanningAuthorityFilter from './filters/HARLocalPlanningAuthorityFilter';
import HARNationalParkFilter from './filters/HARNationalParkFilter';
import HARNewEntriesFilter from './filters/HARNewEntriesFilter';
import HARParishFilter from './filters/HARParishFilter';
import HARParliamentaryConstituencyFilter from './filters/HARParliamentaryConstituencyFilter';
import HARSiteSubTypeFilter from './filters/HARSiteSubTypeFilter';
import HARSiteTypeFilter from './filters/HARSiteTypeFilter';
import HARTrendFilter from './filters/HARTrendFilter';
import HARVulnerabilityFilter from './filters/HARVulnerabilityFilter';
import HARGovernmentRegionFilter from './filters/HARGovernmentRegionFilter';

export default function HARSearchFilters() {
  return (
    <>
      <HARNewEntriesFilter />

      <FormGroup title="Heritage category / grade">
        <HARHeritageCategoriesFilter />
        <HARGradeFilter />
      </FormGroup>

      <FormGroup title="Site type">
        <HARSiteTypeFilter />
        <HARSiteSubTypeFilter />
      </FormGroup>

      <FormGroup title="Risk">
        <HARAssessmentTypeFilter />
        <HARConditionFilter />
        <HARVulnerabilityFilter />
        <HARTrendFilter />
      </FormGroup>

      <FormGroup title="Location">
        <HARLocalPlanningAuthorityFilter />
        <HARCountyFilter />
        <HARDistrictFilter />
        <HARParishFilter />
        <HARNationalParkFilter />
        <HARParliamentaryConstituencyFilter />
        <HARHistoricEnglandRegionFilter />
        <HARGovernmentRegionFilter />
      </FormGroup>
    </>
  );
}
